import { Flex, Box, Button, TextInput } from '@mantine/core';
import { IconChevronLeft, IconBellRinging } from '@tabler/icons-react';
import Loader from 'components/Loader';
import useLang from 'lang';
import SimpleLayout from 'layouts/SimpleLayout';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FORBIDDEN_PAGE_PATH, HOUSE_PAGE_PATH } from 'routes/paths';
import theme from 'theme';
import H1SemiBold from 'theme/components/Typography/H1SemiBold';
import P2Medium from 'theme/components/Typography/P2Medium';
import { useApi } from 'api/api-context';
import panic from 'panic';

/**
 * Door bell page
 */
const DoorBell: React.FC = () => {
  const { _t } = useLang();
  const { getAction } = useApi();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [doorBell, setDoorBell] = useState('');

  /**
   * Load current user's doorbell name from API
   */
  useEffect(() => {
    const getCurrentUser = getAction('GetCurrentUser');

    getCurrentUser({})
      .then((response) => {
        if (response.user?.parent !== null && response.user?.parent !== undefined) {
          navigate(FORBIDDEN_PAGE_PATH.original, { replace: true });
          return;
        }

        const name = response.user?.doorbellName || null;
        setDoorBell(name || '');
        setLoading(false);
      })
      .catch(panic);
  }, [getAction, navigate]);

  /**
   * Handle save
   */
  const handleSave = () => {
    setSaving(true);

    const updateDoorbellName = getAction('UpdateUserDoorbellName');

    updateDoorbellName({ payload: { doorbellName: doorBell } })
      .then(() => {
        setSaving(false);
      })
      .catch(panic);
  };

  return (
    <SimpleLayout>
      <Box p="1rem">
        <Box mb="1rem">
          <Flex>
            <Link
              to={HOUSE_PAGE_PATH.original}
              style={{
                textDecoration: 'none',
                display: 'flex',
                alignContent: 'center',
                marginBottom: '0.5rem',
              }}
            >
              <IconChevronLeft size="1.5rem" color={theme.colors?.gray?.[9]} />

              <P2Medium color={theme.colors?.gray?.[9]}>{_t('Back to my household')}</P2Medium>
            </Link>
          </Flex>

          <Flex gap="0.5rem" align="center">
            <IconBellRinging size="2rem" color={theme.colors?.gray?.[12]} />

            <H1SemiBold color={theme.colors?.gray?.[12]}>{_t('Door bell name')}</H1SemiBold>
          </Flex>
        </Box>

        {loading ? (
          <Loader />
        ) : (
          <>
            <TextInput
              placeholder={_t('Enter door bell name')}
              value={doorBell}
              onChange={(event) => setDoorBell(event.currentTarget.value)}
              mb="0.5rem"
            />
            <Button fullWidth size="md" onClick={handleSave} loading={saving}>
              {_t('Save')}
            </Button>
          </>
        )}
      </Box>
    </SimpleLayout>
  );
};

export default DoorBell;
